import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ShipTheory.frontend.types'

@Injectable({ providedIn: 'root' })
export class ShipTheory_get_carrier_service_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { carrier_name: string, carrier_service_name: string }): Promise<{ carrier_service_id?: number, reason?: string, carrier_id?: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.carrier_name)) {
      missingRequiredInParams.push('\'carrier_name\'');
    }
    if (isNil(inParams.carrier_service_name)) {
      missingRequiredInParams.push('\'carrier_service_name\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ShipTheory/functions/get_carrier_service_id`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

